import { usePaginatedApi } from "../../../swr/useApi";
import { paymentsMeService } from "../../api_client";
import type {
  PaymentDto,
  UnpaidBillsQueryDto,
  VendorBillDto,
} from "../../../api";

/**
 * The generated service exposes the payments list with positional query
 * arguments, so this hook adapts the common query object into the generated
 * signature.
 */
export type { VendorBillDto };
export type MyPaymentsQuery = UnpaidBillsQueryDto;

export function useMyPayments(query?: MyPaymentsQuery) {
  return usePaginatedApi<PaymentDto, MyPaymentsQuery>({
    key: "payments-me-payments",
    serviceMethod: async (q) =>
      paymentsMeService.getMyPayments(
        q.page,
        q.pageSize,
        q.search,
        q.sortBy,
        q.sortOrder,
        q.originRef,
        q,
      ),
    query,
  });
}

export function useMyUnpaidBills(query?: MyPaymentsQuery) {
  return usePaginatedApi<VendorBillDto, MyPaymentsQuery>({
    key: "payments-me-unpaid-bills",
    serviceMethod: async (q) =>
      paymentsMeService.getMyUnpaidBills(
        q.page,
        q.pageSize,
        q.search,
        q.sortBy,
        q.sortOrder,
        q.originRef,
        q,
      ),
    query,
  });
}
